import React, { ReactNode } from 'react';
import { Button } from 'components';
import styles from './ConfirmationAlertsModal.module.scss';
import classNames from 'classnames';
import ReactModal from 'react-modal';

type AlertsModalProps = {
  readonly icon?: ReactNode;
  readonly title?: string;
  readonly text?: string;
  readonly messages?: ReadonlyArray<string>;
  readonly buttonText?: string;
  readonly onConfirm?: () => Promise<void>;
  readonly hideModal: () => void;
  readonly isOpen: boolean;
};

export const AlertModal: React.FC<AlertsModalProps> = ({
  icon,
  title,
  text,
  messages,
  buttonText = 'Ok',
  hideModal,
  onConfirm,
  isOpen,
  ...rest
}): React.ReactElement => {
  return (
    <ReactModal
      isOpen={isOpen}
      className="modal__window"
      overlayClassName="modal__overlay"
      shouldCloseOnOverlayClick
      onRequestClose={hideModal}
      ariaHideApp={false}
      {...rest}
    >
      <div
        className={classNames(styles['modal-wrapper'], 'white-box')}
        data-testid="alert-modal"
      >
        <div className={styles['modal-container']}>
          <div className={styles['modal-content']}>
            {icon && <div className={styles['icon']}>{icon}</div>}

            <div className={styles['modal-header']}>
              <div className={styles['modal-title']}>{title}</div>
              <div className={styles['modal-message']}>{text}</div>
              {messages
                ? messages.map((message, index) => (
                    <div key={index} className={styles['modal-message']}>
                      {message}
                    </div>
                  ))
                : null}
            </div>
          </div>
          <div className={styles['button-container']}>
            <Button
              dataTestId="confirm-cancel"
              className={styles['secondary-button']}
              onClick={() => {
                onConfirm && onConfirm();
                hideModal();
              }}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};
